import React from "react";
import { useAppState } from "src/state";
import { ObjectCardItem } from "src/components/ui/ObjectCard";
import { Box, Divider, Paper, SimpleGrid, Stack } from "@mantine/core";
import { typedEntries } from "src/state/_types";

import { AgencyOperationsAdminVenueBookingViewSchema } from "src/components/agency/operations/administrator/venues/bookings/AgencyOperationsAdminVenueBookingViewSchema";

export function AgencyOperationsAdminVenueBookingView() {

    const { currentItem } = useAppState().bookings;

    if (!currentItem) return null;

    return (

        <Stack gap="sm">

            <Divider
                my="0"
                variant="dashed"
                labelPosition="left"
                label={<Box ml={5}>Booking Overview</Box>}
            />

            <Paper shadow="xs" withBorder p="sm">

                <SimpleGrid cols={5} spacing="xs">
                    {AgencyOperationsAdminVenueBookingViewSchema.enums.map((item) => {
                        const value = "relation_field" in item && item.relation_field != null
                            ? (currentItem[item.field] as Record<string, unknown>)?.[item.relation_field as string]
                            : currentItem[item.field];
                        return (
                            <ObjectCardItem key={item.field} label={item.label} value={value} type={item.type} />
                        )
                    })}

                    {AgencyOperationsAdminVenueBookingViewSchema.fields.map(({ label, field, type }) => {
                        return (
                            <ObjectCardItem key={field} label={label} value={currentItem[field]} type={type} />
                        )
                    })}


                </SimpleGrid>

            </Paper>

            {AgencyOperationsAdminVenueBookingViewSchema.relations
                ? typedEntries(AgencyOperationsAdminVenueBookingViewSchema.relations).map(([relKey, relSchema]) => {
                    const rel = currentItem[relKey];                // T[K]
                    if (!rel) return null;
                    const entity = rel as NonNullable<typeof rel>; // strip Maybe/undefined

                    if (!relSchema) return null;

                    const rows = relSchema.fields.map(({ label, field, type }) => ({
                        label,
                        type,
                        value: entity[field],   // field is keyof NonNullable<T[K]> ✅
                    }));

                    return (
                        <React.Fragment key={String(relKey)}>

                            <Divider
                                my="0"
                                variant="dashed"
                                labelPosition="left"
                                label={<Box ml={5}>{relSchema.label}</Box>}
                            />

                            <Paper key={String(relKey)} shadow="xs" withBorder p="sm">

                                <SimpleGrid cols={5}>
                                    {rows.map(({ label, value, type }) => (
                                        <ObjectCardItem key={label} label={label} value={value} type={type} />
                                    ))}
                                </SimpleGrid>

                            </Paper>
                        </React.Fragment>
                    );
                })
            : null}

        </Stack>

    );
}